import React from 'react'

import Navbar from '../inc/Navbar'
import Slider from '../inc/Slider'
import Contactform from './Contactfrom'

import carrelocation from "../images/Car Relocation.jpg";
import bikeshifting from "../images/bike Shifting.jpg"
import Homeshofting from "../images/Home Shifting.jpg";
import atmrelocation from "../images/Atm Relocation.jpg";

import officeshifting from "../images/Office_Shifting new.jpg";
import internationalshifting from "../images/international shifting.jpg";
import cityreloation from "../images/within city relocation.jpg";
import wirehousestorage from "../images/wirehouse_shifting.jpg";

import corporateshifting from "../images/Corporate Shifting.jpg";
import abouttalk from "../images/public.jpg";
import bestpackersbarrackpore from "../images/public2.jpg";
import bestmoversSodepur from "../images/public1.jpg";
import safepackersinranaghat from "../images/Sit Back and Relax.jpg";

import paking from "../images/packing&unpacking.png"
import expert from "../images/expert_crating.png";
import Specialhandling from "../images/special_handling.png";
import Insurance from "../images/insurance new.png"
import furnitureprotection from "../images/funiture_protection.png";
import ScrollToTop from "react-scroll-to-top"

import "./Home.css";


import ManualCountUp from './ManualCountUp';
import Served from './Served';
import Refferal from './Refferal';
import Clients from './Clients';
import ShiftingProcess from './ShiftingProcess';
import Callback from './Callback';
import VideoGallery from './VideoGallery';

import { FaFacebookF, FaInstagram, FaWhatsapp, FaYoutube } from "react-icons/fa";
import Homepage from './Homepage';


function Home() {
  const phoneNumber = "918101278298"; // Replace with your number (with country code, no +)
  const message = "Hello, I am interested in your services!";

  const encodedMessage = encodeURIComponent(message);
  const whatsappURL = `https://wa.me/${918101278298}?text=${encodedMessage}`;


  return (
    <div>
      <Navbar />
      <br />
      <br />
      <br />
      <br />
      
      <div className="album py-2">
        <div className="container">

          <div className="row">
            <div className="col-md-9 mt-3">
              <Slider />
            </div>
            <div className="col-md-3 mt-3">
              <div className='packer_Rajarhatkolkata'>
                <Contactform />
              </div>
            </div>
          </div>

        </div>

      </div>


  <div className="social-sidebar">
      <a href="https://www.facebook.com/profile.php?id=61579440713642" className="social-link facebook" target="_blank" rel="noreferrer">
        <span className="icon"> <FaFacebookF /></span>
        <span className="text">Facebook</span>
      </a>
      <a href="https://www.instagram.com/atindiapackersmovers/" className="social-link instagram" target="_blank" rel="noreferrer">
        <span className="icon"> <FaInstagram /></span>
        <span className="text">Instagram</span>
      </a>
     
      <a href="https://www.youtube.com/@ATINDIAPACKERSMOVERS" className="social-link youtube" target="_blank" rel="noreferrer">
        <span className="icon"> <FaYoutube /></span>
        <span className="text">YouTube</span>
      </a>
    </div>

      {/* style={{ margin: "9px" }} */}
      <ScrollToTop smooth top="100" color="#020d52ff" />

      <div style={{ color: "white", padding: "8px;", margin: 6 }} className="fixed-bottom">
        <a className='packernaida' href={whatsappURL} target="_blank" rel="noopener noreferrer">
          <button className='packernaida' style={{ backgroundColor: "#1B8755", color: "white", }}>
            <svg xmlns="http://www.w3.org/2000/svg" width="23" height="23" fill="currentColor" class="bi bi-whatsapp" viewBox="0 0 16 16">
              <path d="M13.601 2.326A7.85 7.85 0 0 0 7.994 0C3.627 0 .068 3.558.064 7.926c0 1.399.366 2.76 1.057 3.965L0 16l4.204-1.102a7.9 7.9 0 0 0 3.79.965h.004c4.368 0 7.926-3.558 7.93-7.93A7.9 7.9 0 0 0 13.6 2.326zM7.994 14.521a6.6 6.6 0 0 1-3.356-.92l-.24-.144-2.494.654.666-2.433-.156-.251a6.56 6.56 0 0 1-1.007-3.505c0-3.626 2.957-6.584 6.591-6.584a6.56 6.56 0 0 1 4.66 1.931 6.56 6.56 0 0 1 1.928 4.66c-.004 3.639-2.961 6.592-6.592 6.592m3.615-4.934c-.197-.099-1.17-.578-1.353-.646-.182-.065-.315-.099-.445.099-.133.197-.513.646-.627.775-.114.133-.232.148-.43.05-.197-.1-.836-.308-1.592-.985-.59-.525-.985-1.175-1.103-1.372-.114-.198-.011-.304.088-.403.087-.088.197-.232.296-.346.1-.114.133-.198.198-.33.065-.134.034-.248-.015-.347-.05-.099-.445-1.076-.612-1.47-.16-.389-.323-.335-.445-.34-.114-.007-.247-.007-.38-.007a.73.73 0 0 0-.529.247c-.182.198-.691.677-.691 1.654s.71 1.916.81 2.049c.098.133 1.394 2.132 3.383 2.992.47.205.84.326 1.129.418.475.152.904.129 1.246.08.38-.058 1.171-.48 1.338-.943.164-.464.164-.86.114-.943-.049-.084-.182-.133-.38-.232" />
            </svg>
          </button>
        </a>
      </div>
      <div className="fixed top-1/3 left-0 z-50 flex flex-col gap-3 p-2">

      </div>
      <div className="album py-1">
        <div className="container">
          <center>
            <h1 className='newtext' style={{ color: "#090B7D" }}><b>OUR SERVICES</b></h1>
          </center>
        </div>
      </div>
      <div className="album py-0">
        <div className="container">
          <div className="row">
            <div className="col-md-6">
              <div className="d-flex justify-content-start align-items-center mb-2">
                <div className="col-md-6 me-2 mt-3">
                  <div className='cardmotation'>
                    <a href='car-relocation' target='_blank' rel="noopener noreferrer">
                      <div className="card">

                        <img src={carrelocation} className="card-img-top" alt="carrelocation" />

                      </div>
                      <h5 style={{ color: "#7f0934ff" }} className='mt-2'><center>Car Relocation</center></h5>

                    </a>


                  </div>

                </div>
                
<div className="col-md-6  mt-3">
                  <div className='cardmotation'>
                    <a href='WarehouseStorage'>
                      <div className="card">
                        <img src={wirehousestorage} className="card-img-top" alt="wirehousestorage" />


                      </div>
                      <h5 style={{ color: "#7f0934ff" }} className='mt-2'><center>wirehouse storage</center></h5>
                    </a>
                  </div>
                </div>



              </div>
            </div>
            <div className="col-md-6">
              <div className="d-flex justify-content-start align-items-center mb-2">
                <div className="col-md-6 me-2 mt-3">
                  <div className='cardmotation'>
                    <a href='home-shifting'>
                      <div className="card">

                        <img src={Homeshofting} className="card-img-top" alt="Homeshofting" />


                      </div>
                    </a>
                    <h5 style={{ color: "#7f0934ff" }} className='mt-2'><center>Home Shifting</center></h5>
                  </div>
                </div>
                <div className="col-md-6  mt-3">
                  <div className='cardmotation'>
                    <a href='atmrelocation'>
                      <div className="card">
                        <img src={atmrelocation} className="card-img-top" alt="atmrelocation" />


                      </div>
                      <h5 style={{ color: "#7f0934ff" }} className='mt-2'><center>ATM Relocation</center></h5>
                    </a>
                  </div>

                </div>
              </div>
            </div>

          </div>
        </div>
      </div>

      <div className="album py-1">
        <div className="container">
          <div className="row">
            <div className="col-md-6">
              <div className="d-flex justify-content-start align-items-center mb-2">
                <div className="col-md-6 me-2 mt-3">
                  <div className='cardmotation'>
                    <div className="card">
                      <a href='office-shifting' target='_blank' rel="noopener noreferrer">
                        <img src={officeshifting} className="card-img-top" alt="officeshifting" />
                      </a>
                    </div>

                    <h5 style={{ color: "#7f0934ff" }} className='mt-2'><center>Office Shifting</center></h5>




                  </div>

                </div>
                <div className="col-md-6  mt-3">
                  <div className='cardmotation'>

                    <a href='International-relocation'>
                      <div className="card">

                        <img src={internationalshifting} className="card-img-top" alt="internationalshifting" />

                      </div>
                      <h5 style={{ color: "#7f0934ff" }} className='mt-2'><center>International </center></h5>
                    </a>

                  </div>

                </div>

              </div>
            </div>
            <div className="col-md-6">
              <div className="d-flex justify-content-start align-items-center mb-2">
                <div className="col-md-6 me-2 mt-3">
                  <div className='cardmotation'>
                    <a href='CityRelocation'>
                      <div className="card">
                        <img src={cityreloation} className="card-img-top" alt="cityreloation" />
                      </div>
                      <h5 style={{ color: "#7f0934ff" }} className='mt-2'><center>City Relocation</center></h5>
                    </a>
                  </div>
                </div>
                <div className="col-md-6  mt-3">
                  <div className='cardmotation'>
                    <a href='bike-relocation'>
                    <div className="card">
                      <a href='bike-relocation' target='_blank' rel="noopener noreferrer">
                        <img src={bikeshifting} className="card-img-top" alt="bikeshifting" />
                      </a>

                    </div>
                    <h5 style={{ color: "#7f0934ff" }} className='mt-2'><center>Bike Relocation</center></h5>
                    </a>
                  </div>
                  

                </div>
                
              </div>
            </div>

          </div>
        </div>
      </div>
      <br />
      <br />
      <div className='packersnadia'>
        <br />
        <div className="album py-1">
          <div className="container">
            <div className="row">
              <div className="col-md-7">

                <div className="card-body">
                  <h1 className="card-title  mb-3">Best Packers and Movers in India</h1>
                  <p className="card-text justify">AT India Packers Movers, we are proud to be recognized as one of the most trusted and affordable relocation service providers in India. With a clear focus on reliability, safety, and cost-effectiveness, we have been helping families and businesses move with ease and confidence. Why We’re Different:- 100% Client Satisfaction Rate, Transparent Pricing – No Hidden Costs, On-Time Delivery with Real-Time Tracking, Fully Insured & Damage-Free Relocation, Round-the-Clock Customer Assistance</p>
                  <p className='justify'>Whether it’s local shifting or interstate relocation, our team of trained professionals ensures that every item is packed, handled, and delivered with the utmost care. We combine modern logistics solutions with personalized service to offer seamless moving experiences—every time, at prices that fit your budget. <a href='aboutus'> <b>Read More <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-arrow-right" viewBox="0 0 16 16">
                    <path fill-rule="evenodd" d="M1 8a.5.5 0 0 1 .5-.5h11.793l-3.147-3.146a.5.5 0 0 1 .708-.708l4 4a.5.5 0 0 1 0 .708l-4 4a.5.5 0 0 1-.708-.708L13.293 8.5H1.5A.5.5 0 0 1 1 8" />
                  </svg></b></a></p>


                </div>
              </div>

              <div className="col-md-5">

                <img src={corporateshifting} className="card-img-top" alt="corporateshifting" />
              </div>
            </div>
          </div>
        </div>
        <br />
        <br />
      </div>

      <div className='homepage'>
        <br />

        <div className="container">
          <center>
            <h2 style={{ color: "#090447ff" }}><b>How AT India Packers Movers Work?</b></h2>
          </center>
        </div>
        <br />

        <div className="album py-1">
          <div className="container">
            <div className="row">
              <div className="col-md-3 mt-2">
                <div className="back" >
                  <img src={abouttalk} className="card-img-top" alt="Best Packer in Kalyani" />
                  <div className="card-body">
                    <h5 style={{ color: "#0b0180ff" }} className="card-title mt-2 mb-2">Tell Us About Your Move</h5>
                    <p className="card-text">Tell us about your move — your new location, preferred moving date, and what needs to be transported</p>

                  </div>
                </div>
              </div>
              <div className="col-md-3 mt-2">
                <div className="back" >
                  <img src={bestpackersbarrackpore} className="card-img-top" alt="bestpackersbarrackpore" />
                  <div className="card-body">
                    <h5 style={{ color: "#0b0180ff" }} className="card-title mt-2 mb-2">Schedule Pre-move Survey</h5>
                    <p className="card-text">We will perform a detailed pre-move inspection to ensure an exact and fair pricing quote.</p>
                  </div>
                </div>
              </div>
              <div className="col-md-3 mt-2">
                <div className="back" >
                  <img src={bestmoversSodepur} className="card-img-top" alt="bestmoversSodepur" />
                  <div className="card-body">
                    <h5 style={{ color: "#0b0180ff" }} className="card-title mt-2 mb-2">Get Free Quotations from AT India Packers</h5>
                    <p className="card-text">Request a free quote from AT India Packers Movers and enjoy the most competitive rates</p>
                  </div>
                </div>
              </div>
              <div className="col-md-3 mt-2">
                <div className="back" >
                  <img src={safepackersinranaghat} className="card-img-top" alt="safepackersinranaghat" />
                  <div className="card-body">
                    <h5 style={{ color: "#0b0180ff" }} className="card-title mt-2 mb-2">Sit Back and Relax at best price</h5>
                    <p className="card-text">To ensure value for money, review all moving quotes meticulously before finalizing your mover.</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <br />
        <br />

      </div>

      <div className="album py-1">
        <div className="container">
          <div className="row">
            <div className="col-md-4 mt-2">
              <div className='backnew'>
                <center>
                  <h4 style={{ color: "#0b1151ff" }} className='mb-1'>YEARS OF EXPERIENCE</h4>
                  <ManualCountUp />
                </center>
              </div>
              <div className='backnew mt-2'>
                <center>
                  <h4 style={{ color: "#0b1151ff" }} className='mb-1'>CUSTOMERS SERVED</h4>
                  <Served />
                </center>
              </div>
              <div className='backnew mt-2'>
                <center>
                  <h4 style={{ color: "#0b1151ff" }} className='mb-0'>CUSTOMER REFFERAL RATE</h4>
                  <Refferal />
                </center>
              </div>
            </div>
            <div className="col-md-8 mt-2">
              <center><h2 className='mb-4' style={{ color: "#9C0545" }}><b>Your Trusted Partner in Relocation</b></h2></center>
              <div className="container">
                <div className="row">
                  <div className="col-md-3 mt-2">
                    <center>
                      <img src={paking} height="75px" width="80px" alt="atindiapackers" />
                      <h5 style={{ color: "#9C0545" }} className="card-title mt-2 mb-2">Packing services</h5>
                    </center>
                  </div>
                  <div className="col-md-3 mt-2">
                    <center>
                      <img src={expert} height="75px" width="80px" alt="atindiapackers" />
                      <h5 style={{ color: "#9C0545" }} className="card-title mt-2 mb-2">Expert crating</h5>
                    </center>
                  </div>
                  <div className="col-md-3 mt-2">
                    <center>
                      <img src={Specialhandling} height="75px" width="80px" alt="Specialhandling packers movers in Kolkata" />

                      <h5 style={{ color: "#9C0545" }} className="card-title mt-2 mb-2">Special handling</h5>
                    </center>


                  </div>
                  <div className="col-md-3 mt-2">
                    <center>
                      <img src={furnitureprotection} height="75px" width="80px" alt="furnitureprotection" />

                      <h5 style={{ color: "#9C0545" }} className="card-title mt-2 mb-2">Furniture protection</h5>
                    </center>


                  </div>
                  <div className="col-md-3 mt-2">
                    <center>
                      <img src={Insurance} height="75px" width="80px" alt="atindiapackers" />

                      <h5 style={{ color: "#9C0545" }} className="card-title mt-2 mb-2">Insurance</h5>
                    </center>


                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <br />
      </div>

      <Clients/>
      <ShiftingProcess/>
      <Callback />
       <div className='homepage'>
        <br />

        <div className="container">
          <center>
            <h2 style={{ color: "#090447ff" }}><b>VIDEO GALLERY</b></h2>
          </center>
        </div>
        <VideoGallery/>
         <br />
        </div>

      <Homepage/>
     


    </div>
  )
}

export default Home